import { InformativePage } from "../components";

interface PrivacyPolicyPageContentProps {
  page: any;
}

export function PrivacyPolicyPageContent({
  page,
}: PrivacyPolicyPageContentProps) {
  return <InformativePage page={page} />;
}
